export interface CouponTemplateDto {
  couponTemplateNumber: string;
  name: string;
  displayedCouponName?: string;
  description?: string;
  couponImageUrl?: string;
  infoTextForEndUsers?: string;
  activationType: "FREE" | "POINTS" | "PURCHASABLE";
  requiredPoints?: number;
  purchasePrice?: number;
  status: "ACTIVE" | "INACTIVE";
  valueType: "PERCENTAGE" | "FIXED_AMOUNT" | "GIFT" | "FREE_SHIPPING";
  discountPercentage?: number;
  discountAmount?: number;
  validFrom: string;
  validTo?: string;
  validityPeriodDays: number;
  maxCouponsPerMember?: number;
}

export interface IssuedCouponDto {
  couponNumber: string;
  couponTemplate: {
    couponTemplateNumber: string;
    maxCouponsPerMember: number;
    valueType: "PERCENTAGE" | "FIXED_AMOUNT" | "GIFT" | "FREE_SHIPPING";
    discountPercentage?: number;
    discountAmount?: number;
    displayedCouponName?: string;
    description?: string;
    couponImageUrl?: string;
    infoTextForEndUsers?: string;
  };
  customerNumber: string;
  familyNumber: string;
  status: "INACTIVE" | "ACTIVATED" | "REDEEMED" | "EXPIRED" | "CANCELLED" | "PURCHASABLE" | "UPCOMING";
  issuedAt: string;
  expiresAt: string;
  code?: string;
}

export interface PaginatedCouponTemplatesDto {
  data: CouponTemplateDto[];
  count: number;
  total: number;
}

export interface PaginatedIssuedCouponsDto {
  data: IssuedCouponDto[];
  count: number;
  total: number;
}

export function getCouponValue(template: CouponTemplateDto): string {
  switch (template.valueType) {
    case "PERCENTAGE":
      return template.discountPercentage ? `${template.discountPercentage}%` : "Percentage Off";
    case "FIXED_AMOUNT":
      return template.discountAmount ? `€${template.discountAmount}` : "Fixed Discount";
    case "FREE_SHIPPING":
      return "Free Shipping";
    case "GIFT":
      return "Gift";
    default:
      return "";
  }
}

export function formatCouponStatus(status: string): string {
  switch (status) {
    case "INACTIVE":
      return "Inactive";
    case "ACTIVATED":
      return "Active";
    case "REDEEMED":
      return "Redeemed";
    case "EXPIRED":
      return "Expired";
    case "CANCELLED":
      return "Cancelled";
    case "PURCHASABLE":
      return "Available for Purchase";
    case "UPCOMING":
      return "Coming Soon";
    default:
      return status;
  }
}

export function getCouponTypeColor(valueType: string): { primary: string; secondary: string; gradient: string } {
  switch (valueType) {
    case "PERCENTAGE":
      return {
        primary: "#e74c3c",
        secondary: "#c0392b", 
        gradient: "linear-gradient(135deg, #e74c3c 0%, #c0392b 100%)"
      };
    case "FIXED_AMOUNT":
      return {
        primary: "#f39c12",
        secondary: "#e67e22",
        gradient: "linear-gradient(135deg, #f39c12 0%, #e67e22 100%)"
      };
    case "FREE_SHIPPING":
      return {
        primary: "#27ae60",
        secondary: "#229954",
        gradient: "linear-gradient(135deg, #27ae60 0%, #229954 100%)"
      };
    case "GIFT":
      return {
        primary: "#9b59b6",
        secondary: "#8e44ad",
        gradient: "linear-gradient(135deg, #9b59b6 0%, #8e44ad 100%)"
      };
    default:
      return {
        primary: "#34495e",
        secondary: "#2c3e50",
        gradient: "linear-gradient(135deg, #34495e 0%, #2c3e50 100%)"
      };
  }
}